import { lazy, Suspense } from 'react';
import { ErrorBoundary } from '@sentry/react';

import ExternalLayout from 'src/layouts/external';
import SentryErrorPage from 'src/pages/SentryErrorPage';
import AuthModernCompactLayout from 'src/layouts/auth/modern-compact';
import ReferenceLandingPage from 'src/pages/external/references/reference-landing-page';

import { SplashScreen } from 'src/components/loading-screen';

const ExperienceVerificationPage = lazy(
  () => import('src/pages/external/experience-verification-page')
);

const JobBoardPage = lazy(
  () => import('src/pages/external/job-boards/job-board-page')
);

const EventLandingPage = lazy(
  () => import('src/pages/external/bookable-event/event-landing-page')
);

const SigningSignPage = lazy(() => import('src/pages/external/signing/signing-sign-page'));

const GuestPortalPage = lazy(() => import('src/pages/external/guest-portal/guest-portal-page'));

export const externalRoutes = [
  {
    path: 'experience-verification/:request_id',
    element: (
      <ErrorBoundary fallback={<SentryErrorPage />}>
        <Suspense fallback={<SplashScreen />}>
          <AuthModernCompactLayout>
            <ExperienceVerificationPage />
          </AuthModernCompactLayout>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: 'job-boards/:board_id/jobs',
    element: (
      <ErrorBoundary fallback={<SentryErrorPage />}>
        <Suspense fallback={<SplashScreen />}>
          <ExternalLayout>
            <JobBoardPage />
          </ExternalLayout>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: 'reference-manager/:reference_request_id/submit-reference',
    element: (
      <ErrorBoundary fallback={<SentryErrorPage />}>
        <Suspense fallback={<SplashScreen />}>
          <ExternalLayout>
            <ReferenceLandingPage />
          </ExternalLayout>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: '/event-scheduler/events/:bookable_event_type_id',
    element: (
      <ErrorBoundary fallback={<SentryErrorPage />}>
        <Suspense fallback={<SplashScreen />}>
          <ExternalLayout>
            <EventLandingPage />
          </ExternalLayout>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: 'signing/sign/:token',
    element: (
      <ErrorBoundary fallback={<SentryErrorPage />}>
        <Suspense fallback={<SplashScreen />}>
          <ExternalLayout>
            <SigningSignPage />
          </ExternalLayout>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: 'guest-portal/:token',
    // Deliberately NOT wrapped in ExternalLayout (JT1-1639). That layout puts the JobTetris logo
    // and Login / Sign-up buttons above the page — a guest is looking at their agency's process,
    // not at an invitation to sign up — and forces `textAlign: center` on everything inside it.
    // The portal renders its own header with the agency's branding instead.
    element: (
      <ErrorBoundary fallback={<SentryErrorPage />}>
        <Suspense fallback={<SplashScreen />}>
          <GuestPortalPage />
        </Suspense>
      </ErrorBoundary>
    ),
  },
];
